// extracted by mini-css-extract-plugin
export default {"CommentList":"CommentList--ZQ54p","title":"title--LP8Mz"};